import React from 'react';

 class StatusButtonRenderer extends React.Component {
    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
      }
      btnClickedHandler=()=> {
        //console.log(this.props.data);

        this.props.showLeakDetection(this.props.data);
       }
      render() {
        return (
            <button class="nomination-btnsz btn btn-primary" onClick={this.btnClickedHandler}>Response Form</button>                
        )
      }
    }
    export default StatusButtonRenderer;